import Clarity from '@microsoft/clarity'

const CLARITY_PROJECT_IDS = {
    kwai: 'wwiwbp3r33',
    snack: 'wwivbvjoz2',
}

export default () => {
    const host = window.location.host
    const projectId = host.includes('snack') ? CLARITY_PROJECT_IDS.snack : CLARITY_PROJECT_IDS.kwai
    Clarity.init(projectId)
}
